<template>
  <div>
    <div class="wf-mt-3">
      <div class="wf-flex wf-justify-between wf-items-center">
        <h4 class="wf-text-xs wf-font-bold wf-uppercase wf-text-gray-500">Components</h4>  
      </div>
    </div>
    <div class="wf-mt-3">
      <div class="wf-bg-gray-200 wf-p-4 wf-rounded-lg wf-border">
        <button
          v-for="component in components"
          :key="component.name"
          class="wf-bg-white wf-w-full hover:wf-shadow-md wf-p-4 wf-rounded-md wf-shadow wf-mb-4 wf-text-center"
          @click.prevent="addComponent(component)"
          v-text="component.name"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
  import { EditorComponentsBuilder } from '../../EditorComponentsBuilder'
  import ArrayManipulation from '../../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    data() {
      return {
        components: new Array
      }
    },
    mounted() {
      this.getComponents()
    },

    methods: {
      getComponents() {
        this.components = (new EditorComponentsBuilder(false, true)).get()
      },
      addComponent(component) {
        this.addToArray('pageModule', [(new EditorComponentsBuilder).create(component.name)], 'components')
        this.$store.commit('updateToolbar', false)
      }
    }
  }
</script>